import React from 'react';
import { oneOfType, string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { getResponseTimeData } from '../../util/data';
import { propTypes } from '../../util/types';
import { IconMessage } from '../../components/Icons';
import css from './UserResponseTime.module.css';

const UserResponseTime = (props) => {
  const { rootClassName, className, iconClassName, textClassName, user } = props;
  const classes = classNames(rootClassName || css.root, className);
  const iconClasses = classNames(css.iconMessage, iconClassName);
  const textClasses = classNames(css.text, textClassName);
  const { hasResponseTimeAverage, responseTimeAverageHours } = getResponseTimeData(user);

  if (!hasResponseTimeAverage) {
    return null;
  }

  return (
    <span className={classes}>
      <IconMessage className={iconClasses} />
      <span className={textClasses}>
        <FormattedMessage
          id="UserResponseTime.responseTimeAverage"
          values={{ responseTimeAverage: responseTimeAverageHours }}
        />
      </span>
    </span>
  );
};

UserResponseTime.defaultProps = {
  rootClassName: null,
  className: null,
  iconClassName: null,
  textClassName: null,
};

UserResponseTime.propTypes = {
  rootClassName: string,
  className: string,
  iconClassName: string,
  textClassName: string,
  user: oneOfType([propTypes.user, propTypes.currentUser]).isRequired,
};

export default UserResponseTime;
